export const themeConfig = {
    theme: {
        colors: {
            primary: "hsl(var(--primary))",
            secondary: "hsl(var(--secondary))",
            accent: "hsl(var(--accent))",
            background: "hsl(var(--background))",
            foreground: "hsl(var(--foreground))",
        },
        fonts: {
            sans: "var(--font-sans)",
            mono: "var(--font-mono)",
        },
        borderRadius: {
            DEFAULT: "0.5rem",
        }
    },
    // Defaults if CSS vars fail or for other usage
    defaults: {
        shopName: "AutoEcom Store",
        currency: "BDT",
    }
};
